<template>
  <div class="upload-img-com">
    <div class="upload-operate" v-show="isUndefinedOrNullOrEmpty(file.previewData)">
      <div class="choose-file-btn">
        <VueWebuploader
          ref="vue_webuploader"
          :options="options"
          @fileQueued="_fileQueued"
          @uploadProgress="_uploadProgress"
          @uploadAccept="_uploadAccept"
          @uploadSuccess="_uploadSuccess"
          @uploadError="_uploadError"
          @error="_error"
        ></VueWebuploader>
        <slot></slot>
      </div>
    </div>
    <div class="preview-box" v-show="!isUndefinedOrNullOrEmpty(file.previewData)">
      <div @click="removeFile" class="upload-remove-btn"></div>
      <img :src="file.previewData" v-if="file.previewData" alt />
      <div class="can-not-preview" v-if="!file.previewData">
        文件
        <span class="text-bold">"{{file.name}}"</span> 不能预览
      </div>
    </div>
    <div class="upload-success-tip" v-show="isUploadSuccess">
      <v-icon>done</v-icon>
    </div>
    <div class="upload-shade" v-show="isProgress || isUploadError || isPreUploadError">
      <div class="shade-content">
        <div class="uploading-tip" v-show="isProgress">
          <v-progress-circular :size="50" indeterminate></v-progress-circular>
          <span class="inline-block vertical-middle color-fff ml-10">上传中...</span>
        </div>
        <div class="upload-error-tip" v-show="isUploadError || isPreUploadError">
          <p class="color-fff mb-5">上传失败，您可以 重新上传 或 删除文件</p>
          <div class="text-center">
            <div class="upload-error-operate-btn clear-btn" title="删除文件" @click="removeFile">
              <v-icon>highlight_off</v-icon>
            </div>
            <div
              class="upload-error-operate-btn refresh-btn"
              title="重新上传"
              v-show="isUploadError"
              @click="retry"
            >
              <v-icon>refresh</v-icon>
            </div>
            <div
              class="upload-error-operate-btn refresh-btn"
              title="重新上传"
              v-show="isPreUploadError"
              @click="_fileQueued(file)"
            >
              <v-icon>refresh</v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueWebuploader from '../VueWebUploader/VueWebuploader';
import { uploadApi } from '@/api/upload.module';

export default {
  name: 'UploadImg',
  props: {
    // 允许上传的文件
    accept: {
      type: String,
      default: 'jpg,jpeg,bmp,png'
    },
    // 是否允许多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 上传时的额外参数
    otherData: {
      type: Object,
      default() {
        return {};
      }
    },
    // 单个文件最大体积(默认5m)
    maxFileSize: {
      type: Number,
      default: 5242880
    },
    type: {
      type: String,
      default: ''
    },
    previewImg: {
      type: String,
      default: ''
    }
  },
  data() {
    let id =
      'UploadImg_' +
      new Date().getTime() +
      '_' +
      Math.random()
        .toString(32)
        .substr(2);
    return {
      id: id,
      // 文件上传相关配置
      options: {
        server: '/',
        // dnd: '#container_' + id,
        pick: {
          // innerHTML: '<svg class="iconfont-symbol" aria-hidden="true"><use xlink:href="#icon-icon-test7"></use></svg>',
          innerHTML: '<span class="add-icon"></span>',
          multiple: false
        },
        formData: {},
        accept: {
          extensions: 'jpg,jpeg,bmp,png',
          mimeTypes: 'image/*'
        }
      },
      file: {
        previewData: ''
      },
      isProgress: false,
      isUploadError: false,
      isPreUploadError: false,
      isUploadSuccess: false
    };
  },
  methods: {
    // 移除图片
    removeFile() {
      let vueWebUploader = this.$refs.vue_webuploader;

      vueWebUploader.removeFile(this.file);

      this.isProgress = false;
      this.isUploadError = false;
      this.isPreUploadError = false;
      this.isUploadSuccess = false;
      this.file = {};
    },
    // 重试上传
    retry() {
      let vueWebUploader = this.$refs.vue_webuploader;

      this.isProgress = true;
      this.isUploadError = false;
      vueWebUploader.retry(this.file);
    },
    // 文件添加进队列事件
    _fileQueued(file) {
      this._preUpload(file);
      this.isUploadError = false;
      this.file = file;
    },
    // 预上传
    _preUpload(file) {
      this.isProgress = true;
      // this.$refs.vue_webuploader.uploader.disable();
      uploadApi
        .preUpload(this.type)
        .then(res => {
          let data = res.data;
          let { dir, policy, signature, callback, accessid, host } = data;
          this.options.server = host + '?_t=' + new Date().getTime();
          let extraData = {
            name: signature,
            key: `${dir}.${file.type.split('/')[1]}`,
            policy: policy,
            OSSAccessKeyId: accessid,
            success_action_status: 200,
            callback: callback,
            signature: signature
          };
          let vueWebUploader = this.$refs.vue_webuploader;

          this.isPreUploadError = false;
          vueWebUploader.addData(file, extraData);
          vueWebUploader.upload(file);
        })
        .catch(() => {
          this.isProgress = false;
          this.isPreUploadError = true;
          // this.$refs.vue_webuploader.uploader.enable();
        });
    },
    // 文件上传中
    _uploadProgress(file, percentage) {
      this.isProgress = true;
      // this.$refs.vue_webuploader.uploader.disable();
      this.$emit('uploadProgress', file, percentage);
    },
    _uploadAccept(obj, res) {
      if (res.Status !== 'ok') {
        return false;
      }
    },
    // 上传成功回调
    _uploadSuccess(file, res) {
      this.isProgress = false;
      this.isUploadError = false;
      this.isUploadSuccess = true;
      // this.$refs.vue_webuploader.uploader.enable();

      this.$emit('uploadSuccess', file, res);
      this.$refs.vue_webuploader.refresh();
    },
    // 上传失败回调
    _uploadError(file, reason) {
      this.isProgress = false;
      this.isUploadError = true;
      // this.$refs.vue_webuploader.uploader.enable();
      this.$emit('uploadError', file, reason);
    },
    // 选择文件错误回调
    _error(errCode) {
      // Q_TYPE_DENIED: 上传文件类型不正确
      // F_EXCEED_SIZE: 上传的文件体积大于设定的体积
      this.$emit('error', errCode);
    }
  },
  components: {
    VueWebuploader
  },
  watch: {
    otherData: {
      handler(newData) {
        let isEmpty = true;
        for (var attr in newData) {
          isEmpty = false;
          break;
        }
        if (!isEmpty) {
          this.options.formData = newData;
        }
      },
      immediate: true
    },
    previewImg: function(value) {
      if (!this.isUndefinedOrNullOrEmpty(value)) {
        this.file.previewData = value;
      }
    }
  },
  mounted() {
    let options = this.options;
    options.pick.multiple = this.multiple;
    options.accept.extensions = this.accept;
    options.fileSingleSizeLimit = this.maxFileSize;
  }
};
</script>

<style src="./uploadimg.styl" lang="stylus"></style>

<style scoped>
.upload-img-com:hover .upload-remove-btn {
  opacity: 1;
}
.upload-remove-btn {
  position: absolute;
  top: 0;
  right: 0;
  border-top: 19px solid #ff5858;
  border-right: 19px solid #ff5858;
  border-left: 19px solid transparent;
  border-bottom: 19px solid transparent;
  z-index: 1;
  opacity: 0;
}
.upload-remove-btn::before,
.upload-remove-btn::after {
  content: '';
  display: inline-block;
  position: absolute;
  width: 14px;
  height: 2px;
  background-color: #fff;
  bottom: 6px;
  left: 7px;
}
.upload-remove-btn::before {
  transform: translate(-50%, -50%) rotate(-45deg);
}
.upload-remove-btn::after {
  transform: translate(-50%, -50%) rotate(45deg);
}
</style>
<style>
/* 解决删除后上传按钮错位的bug */
.webuploader-container > div:not(.webuploader-pick) {
  height: 100% !important;
  width: 100% !important;
}
</style>
